import Actions from '../action'
const initialState = {
    isLoading: false,
    addressType: [],
    error: false
}
export default (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.ADDRESS_TYPE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.ADDRESS_TYPE_SUCCESS: {

            return {
                ...state,
                isLoading: false,
                addressType: action.data.response,
                error: false
            };
        }
        case Actions.ADDRESS_TYPE_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        }
        default:
            return state;
    }
};
